(function(){
if(window.Shopify&&window.Shopify.designMode)return;
var ALLOWED_PATHS=['/pages/postcards-from-provence'];
if(ALLOWED_PATHS.indexOf(window.location.pathname)===-1)return;
var ZONE_SELECTOR='.pcc-zone';
var NOTES=["wish you were here (you basically are)","you are my favourite souvenir","with love from provence xx","bonjour xx","postcards from provence","with love, sophie xx","picked this one just for you","this one's got your name on it","249 more where this came from","bisous xx","mum's asleep on the lilo","you'd hate it here xx","dad tried haggling in lidl","what rhymes with slay?","robbed in marseille","if you stole my art call me I just wanna talk xx","packed 45 pairs of knickers","jokes I only packed 2","eaten 250 croissants","off to practice my dives xx","want to stay here forever","should have on reflection","stolen from a car, painted from the heart","can someone pick up more wine?"];
var DURATION=2400;
var styleEl=document.createElement('style');
styleEl.textContent=ZONE_SELECTOR+"{position:relative;overflow:hidden}";
document.head.appendChild(styleEl);
var zones=document.querySelectorAll(ZONE_SELECTOR);
if(!zones.length)zones=[document.body];
function seededRand(seed){var x=Math.sin(seed)*10000;return x-Math.floor(x);}
function esc(c){return {'<':'&lt;','>':'&gt;','&':'&amp;'}[c]||c;}
function buildHandwritten(text,noteId){
var fonts=["'Reenie Beanie',cursive","'Caveat',cursive","'Homemade Apple',cursive"];
var words=text.split(' ');
var html='';
words.forEach(function(word,wi){
html+="<span style='display:inline-block;white-space:nowrap'>";
word.split('').forEach(function(ch,i){
var gi=wi*100+i;
var r1=seededRand(noteId*97+gi*13.7);
var r2=seededRand(noteId*53+gi*7.3+1);
var r3=seededRand(noteId*31+gi*3.1+2);
var rot=(r1*5-2.5).toFixed(1);
var ty=(r2*2.4-1.2).toFixed(1);
var font=fonts[2];
var scale=(0.96+r3*0.1).toFixed(2);
html+="<span style=\"display:inline-block;font-family:"+font+";transform:rotate("+rot+"deg) translateY("+ty+"px) scale("+scale+")\">"+esc(ch)+"</span>";
});
html+=wi<words.length-1?'&nbsp;':'';
html+="</span>";
});
return html;
}
var seq=0,idc=0;
function spawn(zone,x,y){
var text=NOTES[seq%NOTES.length];seq++;
var id=idc++;
var isBody=zone===document.body;
var rect=isBody?{left:0,top:0,width:window.innerWidth}:zone.getBoundingClientRect();
var lx=isBody?x:x-rect.left,ly=isBody?y:y-rect.top;
var rot=(Math.random()*16-8).toFixed(1);
var dx=(Math.random()*40-20).toFixed(1);
var halfW=75;
var cx=Math.min(Math.max(lx,halfW+4),rect.width-halfW-4);
var wordsArr=text.split(' ');
var longest=0;for(var wi2=0;wi2<wordsArr.length;wi2++)if(wordsArr[wi2].length>longest)longest=wordsArr[wi2].length;
var eff=Math.max(text.length,wordsArr.length*6,longest*4.2);
var fontSize=eff>46?11:eff>40?12:eff>34?14:eff>26?17:eff>18?19:22;
var el=document.createElement('div');
el.className='pcc-note';
el.style.position=isBody?'fixed':'absolute';
el.style.left=cx+'px';el.style.top=ly+'px';
el.style.setProperty('--rot',rot+'deg');
el.style.setProperty('--dx',dx+'px');
el.style.setProperty('--dur',DURATION+'ms');
el.innerHTML="<div class='pcc-body'><div class='pcc-msg' style='font-size:"+fontSize+"px'>"+buildHandwritten(text,id)+"</div><div class='pcc-right'><div class='pcc-stamp'></div><div class='pcc-lines'><span></span><span></span><span></span><span></span></div></div></div>";
zone.appendChild(el);
setTimeout(function(){el.remove();},DURATION);
}
zones.forEach(function(zone){
var touchStart=null;
zone.addEventListener('touchstart',function(e){
var t=e.touches[0];
touchStart={x:t.clientX,y:t.clientY,time:Date.now()};
},{passive:true});
zone.addEventListener('touchmove',function(e){
if(!touchStart)return;
var t=e.touches[0];
if(Math.hypot(t.clientX-touchStart.x,t.clientY-touchStart.y)>10)touchStart=null;
},{passive:true});
zone.addEventListener('touchend',function(e){
if(!touchStart)return;
if(Date.now()-touchStart.time<400){
spawn(zone,touchStart.x,touchStart.y);
}
touchStart=null;
},{passive:true});
zone.addEventListener('pointerdown',function(e){
if(e.pointerType==='touch')return;
spawn(zone,e.clientX,e.clientY);
},{passive:true});
});
})();
